import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {AdminDashboardWrapper} from '../pages/adminDashboard'
import {getHomePath} from '../utils/homePath'
import {PortalsWrapper} from '../pages/portals/PortalsWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import { PagePlantsImportedByCredential } from '../pages/portals/PagePlantsImported'
import { UnitBranchsWrapper } from '../pages/unit-branch'
import { ClientsWrapper } from '../pages/clients'
import { UsersWrapper } from '../pages/users'
import { ReportsWrapper } from '../pages/reports'
import { GenerationAnalysisWrapper } from '../pages/generationAnalysis'
import { UnitConsumerWrapper } from '../pages/unit-consumer'
import { InvoicesWrapper } from '../pages/invoices'
import { ConcessionariesWrapper } from '../pages/concessionaries'
import { TemplatesWrapper } from '../pages/templates'
import { StoreServicesWrapper } from '../pages/storeServices'
import { SettingsWrapper } from '../pages/accontSettings/components/settingsProfile'
import { SettingsCompanyWrapper } from '../pages/accontSettings/components/settingsCompany'
import { SettingsUnitBranchWrapper } from '../pages/accontSettings/components/settingsUnitBranch'
import { SettingsClientWrapper } from '../pages/accontSettings/components/settingsClient'
import { ProposalGeneratorWrapper } from '../pages/proposalGenerator'
import { ExpansionPortfolioWrapper } from '../pages/expansionPortfolio'
import { IntegradorWrapper } from '../pages/page-integrador'
import { CollaboratorsWrapper } from '../pages/collaborators'
import { CompaniesWrapper } from '../pages/companies'
import { useAuth } from '../modules/auth'
import { CatalogoWrapper } from '../pages/catalogo'
import { TagsUsinasWrapper } from '../pages/tagsUsinas'
import { KioskDevicesWrapper } from '../pages/kioskDevices'
import { PublicApiWrapper } from '../pages/publicApi'
import { DocumentationsWrapper } from '../pages/documentations'
import { canAccessPublicApi } from '../utils/publicApiAccess'
import { ControlPanelWrapper } from '../pages/controlPanel'
import { RequestServicesWrapper } from '../pages/requestServices'
import { ServicesOSWrapper } from '../pages/servicesOS'
import { SubscriptionsWrapper } from '../pages/subscriptions/SubscriptionsWrapper'
import { SubscriptionSettingsWrapper } from '../pages/subscriptions/SubscriptionSettingsWrapper'
import ClientSubscriptionsWrapper from '../pages/client-subscriptions/ClientSubscriptionsWrapper'
import { WhatsAppSuccess } from '../pages/accontSettings/components/settingsCompany/components/bodySettingsCompany/components/whatsapp/WhatsAppSuccess'

const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
  const user = useAuth()
  const isAdmin = user.currentUser?.role.slug === 'ADMIN'
  const homePath = getHomePath(user.currentUser?.role.slug)

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route path='auth/*' element={<Navigate to={homePath} />} />

        <Route
          path='dashboard'
          element={isAdmin ? <Navigate to={homePath} replace /> : <DashboardWrapper />}
        />
        <Route
          path='painel-admin'
          element={isAdmin ? <AdminDashboardWrapper /> : <Navigate to='/dashboard' replace />}
        />
        <Route path='painelDeControle' element={<ControlPanelWrapper />} />

        <Route path='integrador' element={<IntegradorWrapper />} />

        {user && user.currentUser?.role.slug !== "CLIENTE" &&(
          <Route path='portals' element={<PortalsWrapper />} />
        )}

        {user.currentUser?.role.slug !== "CLIENTE" &&(
          <Route path='filiais' element={<UnitBranchsWrapper />} />
        )}

        <Route path='consumidoras' element={<UnitConsumerWrapper />} />

        {user.currentUser?.role.slug !== "CLIENTE" && user.currentUser?.role.slug !== "ADMIN" && (
          <Route path='clientes' element={<ClientsWrapper />} />
        )}
        {user.currentUser?.role.slug !== "CLIENTE" &&(
          <Route path='colaboradores' element={<CollaboratorsWrapper />} />
        )}

        {user.currentUser?.role.slug !== "CLIENTE" &&(
          <Route path='usuarios' element={<UsersWrapper />} />
        )}

        <Route path='relatorios' element={<ReportsWrapper />} />
        {user.currentUser?.role.slug !== "CLIENTE" && (
          <Route path='analises-geracao' element={<GenerationAnalysisWrapper />} />
        )}
        <Route path='solicitacoes' element={<RequestServicesWrapper />} />
        <Route path='servicosOS' element={<ServicesOSWrapper />} />
        <Route path='faturas' element={<InvoicesWrapper />} />
        <Route path='concessionarias' element={<ConcessionariesWrapper />} />
        <Route path='templates' element={<TemplatesWrapper />} />
        <Route path='storeServices' element={<StoreServicesWrapper />} />
        {user.currentUser?.role.slug !== "ADMIN" && (
          <Route path='catalogo' element={<CatalogoWrapper />} />
        )}
        {user.currentUser?.role.slug !== "CLIENTE" && user.currentUser?.role.slug !== "ADMIN" && (
          <Route path='tags-usinas' element={<TagsUsinasWrapper />} />
        )}
        {(user.currentUser?.role.slug === "EMPRESA" || user.currentUser?.role.slug === "FILIAL") && (
          <Route path='dispositivos-tv' element={<KioskDevicesWrapper />} />
        )}
        {canAccessPublicApi(user.currentUser) && (
          <Route path='integracao-api' element={<PublicApiWrapper />} />
        )}
        <Route path='storeServices/:page' element={<StoreServicesWrapper />} />

        {user.currentUser?.role.slug !== "CLIENTE" && (
          <Route path='assinaturas' element={<SubscriptionsWrapper />} />
        )}
        {user.currentUser?.role.slug === "CLIENTE" && (
          <Route path='minhas-assinaturas/*' element={<ClientSubscriptionsWrapper />} />
        )}
        {user.currentUser?.role.slug !== "CLIENTE" && (
          <Route path='controles-cobranca' element={<SubscriptionSettingsWrapper />} />
        )}


        {user.currentUser && user.currentUser.companies && user.currentUser.companies.length > 0
          && user.currentUser?.role.slug !== "CLIENTE" && (
            <Route path='proposalGenerator' element={<ProposalGeneratorWrapper />} />
        )}

        {user.currentUser && user.currentUser.companies && user.currentUser.companies.length > 0
          && user.currentUser?.role.slug !== "CLIENTE" && user.currentUser?.role.slug !== "ADMIN" && (
            <Route path='expansao-portfolio' element={<ExpansionPortfolioWrapper />} />
        )}

        <Route path='perfilSettings' element={<SettingsWrapper />} />

        {user.currentUser?.role.slug === "ADMIN" &&(
          <Route path='companies' element={<CompaniesWrapper />} />
        )}
        {user.currentUser?.role.slug === "ADMIN" && (
          <Route path='documentacoes' element={<DocumentationsWrapper />} />
        )}

        <Route path='companySettings' element={<SettingsCompanyWrapper />} />
        <Route path='companySettings/whatsapp/success' element={<WhatsAppSuccess />} />
        <Route path='unitBranchSettings' element={<SettingsUnitBranchWrapper />} />
        <Route path='clientSettings' element={<SettingsClientWrapper />} />
        <Route path='portals/plantImported/:id' element={<PagePlantsImportedByCredential />} />


        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
